import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-destacados-home',
  templateUrl: './destacados-home.component.html',
  styleUrls: ['./destacados-home.component.css'],
})
export class DestacadosHomeComponent implements OnInit {

  safeUrl: SafeResourceUrl;
  
    constructor(
      private authService: AuthService,
      private sanitizer: DomSanitizer
    ) { }
  
    ngOnInit() {
      const acccessToken = this.authService.getToken();
  
      const iframeUrl = `${environment.ADMIN_URL}dashboard/banners?token=${acccessToken}`;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/destacados-home/destacados-home.component.ts